import styled from 'styled-components';

import { Box } from 'Components/Base';

const BlankLayout = styled(Box)`
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
`;

export default BlankLayout;
